'use strict';

module.exports.AppContainer = require('./AppContainer');


//////////////////
// WEBPACK FOOTER
// /app/node_modules/react-hot-loader/lib/index.prod.js
// module id = 898
// module chunks = 0